// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-header {
  background-color: #fff;
  padding: 64px 45px 12px;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 44px;
}

.company-logo {
  width: 100%;
  height: auto;
}

.brand-container {
  display: flex;
  align-items: center;
  margin-left: 12px;
}

.logo-wrapper {
  border-radius: 6px 0 0 6px;
  border: 2px solid #000;
  background-color: #fff;
  padding: 18px 12px;
}

.wire-logo {
  width: 69px;
  height: auto;
}

.brand-name {
  border-radius: 0 6px 6px 0;
  background-color: #000;
  color: #fff;
  padding: 17px 15px;
  font: 400 63px/171% Kanit, sans-serif;
}

.report-title-container {
  display: flex;
  align-items: center;
  margin: 0 18px 46px 19px;
}

.document-icon {
  width: 6px;
  height: auto;
  margin-right: 12px;
}

.report-title {
  font: 700 49px/1.2 Inter, sans-serif;
  color: #000;
}

.section-title {
  color: #000;
  text-transform: uppercase;
  font: 500 12px/167% 'PP Neue Montreal Mono', monospace;
  margin-bottom: 25px;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.3;
}

.company-info {
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #f9f9fd;
  padding: 17px 27px;
  margin-bottom: 28px;
}

.info-grid {
  display: flex;
  gap: 20px;
}

.info-column {
  flex: 1 1;
}

.info-label {
  color: #ff4d53;
  font: 700 10px/200% 'PP Neue Montreal', sans-serif;
}

.info-value {
  color: rgba(0, 0, 0, 0.6);
  font: 500 10px/200% 'PP Neue Montreal', sans-serif;
  margin-bottom: 12px;
}



.social-media-link {
  border-radius: 41px;
  display: flex;
  align-items: center;
  padding: 6px 9px;
  color: #fff;
  font: 400 14px/143% Inter, sans-serif;
  gap: 5px;
}

.social-icon {
  width: 14px;
  height: 14px;
  margin-right: 6px;
}

.header-footer,
.content-footer {
  margin-top: 9px;
  font: 400 10px/200% Inter, sans-serif;
  color: #000;
}
.footer-content{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.decorative-line {
  width: 100%;
  height: 1px;
  background-color: #b7b7b7;
  margin-bottom: 9px;
}

.report-content {
  background-color: #fff;
  /* margin: 0 145px; */
  padding: 45px;
  margin-top: 45px;
}

.press-release-summary {
  margin-bottom: 26px;
}

.press-release-title {
  color: #000;
  font: 500 16px/20px 'PP Neue Montreal', sans-serif;
  margin: 25px 0 11px;
}

.submission-date {
  color: rgba(0, 0, 0, 0.6);
  font: 400 10px 'PP Neue Montreal', sans-serif;
}

.metrics-container {
  display: flex;
  gap: 20px;
  margin-top: 26px;
}

.metric-item {
  flex: 1 1;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #f9f9fd;
  padding: 23px 36px;
  text-align: center;
}

.metric-title {
  color: #000;
  font: 500 12px/167% 'PP Neue Montreal', sans-serif;
}

.metric-value {
  color: #ff4d53;
  font: 700 69px/143% 'PP Neue Montreal', sans-serif;
  margin-top: 24px;
}

.pickup-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pickup-row {
  display: flex;
  gap: 20px;
}

.pickup-section {
  flex: 1 1;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #f9f9fd;
  padding: 15px;
  text-align: center;
}

.pickup-title {
  color: #000;
  font: 500 12px/167% 'PP Neue Montreal', sans-serif;
  margin-bottom: 16px;
}

.platform-logo {
  max-width: 120px;
  height: auto;
  margin-bottom: 16px;
}

.view-release-button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 32px;
  background-color: #ff4d53;
  padding: 5px 10px;
  color: #fff;
  font: 500 10px/200% 'PP Neue Montreal', sans-serif;
  text-transform: capitalize;
}

.arrow-icon {
  width: 7px;
  height: 8px;
  margin-left: 6px;
}

.additional-info-image {
  width: 100%;
  height: auto;
  margin: 16px 0;
}

.press-release-content,
.additional-content {
  background-color: #fff;
  padding: 64px 45px 12px;
  margin-top: 80px;
}

.press-release-text {
  color: rgba(0, 0, 0, 0.6);
  font: 500 13px/1.5 'PP Neue Montreal', sans-serif;
  text-align: justify;
  margin-bottom: 16px;
  max-width: 100%;
  overflow: hidden;
}
.press-release-text img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  object-fit: contain;
}
.editorClassName{
height: 352px !important;
}
.editorClassName img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  object-fit: contain;
}
.editorClassName a span {
  color: #0000FF;
}
.noBorder-editor-wrapper {
  border: none !important;
}
.noBorder-editor-main {
  border: none !important;
  box-shadow: none !important;
}
.rdw-editor-main img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  object-fit: contain;
}
.subsection-title {
  color: #000;
  font: 700 16px 'PP Neue Montreal', sans-serif;
  margin: 30px 0 16px;
}

.company-link {
  color: #0170f3;
  text-decoration: underline;
}

.distribution-list {
  background-color: #fff;
  padding: 64px 45px 12px;
  margin-top: 80px;
}

.distribution-item {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 14px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.distribution-logo {
  width: 43px;
  height: auto;
}

.distribution-link {
  color: #0170f3;
  font: 500 10px/200% 'PP Neue Montreal', sans-serif;
  text-decoration: none;
}

.distribution-type,
.distribution-industry,
.distribution-countries,
.distribution-audience {
  font: 400 10px/100% 'PP Neue Montreal', sans-serif;
  color: rgba(0, 0, 0, 0.6);
}

@media (max-width: 991px) {
  .report-header,
  .report-content,
  .press-release-content,
  .additional-content,
  .distribution-list {
    padding: 40px 20px;
  }

  .brand-name {
    font-size: 40px;
  }

  .report-title {
    font-size: 40px;
  }

  .info-grid {
    flex-direction: column;
  }

  .metric-value {
    font-size: 40px;
  }

  .pickup-row {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/pages/download-report/download.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sDAAsD;EACtD,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EACzB,kDAAkD;EAClD,mBAAmB;AACrB;;;;AAIA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,kDAAkD;EAClD,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iDAAiD;EACjD,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;AACA;AACA,wBAAwB;AACxB;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;;;;EAIE,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE;;;;;IAKE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".report-header {\n  background-color: #fff;\n  padding: 64px 45px 12px;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 44px;\n}\n\n.company-logo {\n  width: 100%;\n  height: auto;\n}\n\n.brand-container {\n  display: flex;\n  align-items: center;\n  margin-left: 12px;\n}\n\n.logo-wrapper {\n  border-radius: 6px 0 0 6px;\n  border: 2px solid #000;\n  background-color: #fff;\n  padding: 18px 12px;\n}\n\n.wire-logo {\n  width: 69px;\n  height: auto;\n}\n\n.brand-name {\n  border-radius: 0 6px 6px 0;\n  background-color: #000;\n  color: #fff;\n  padding: 17px 15px;\n  font: 400 63px/171% Kanit, sans-serif;\n}\n\n.report-title-container {\n  display: flex;\n  align-items: center;\n  margin: 0 18px 46px 19px;\n}\n\n.document-icon {\n  width: 6px;\n  height: auto;\n  margin-right: 12px;\n}\n\n.report-title {\n  font: 700 49px/1.2 Inter, sans-serif;\n  color: #000;\n}\n\n.section-title {\n  color: #000;\n  text-transform: uppercase;\n  font: 500 12px/167% 'PP Neue Montreal Mono', monospace;\n  margin-bottom: 25px;\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.company-info {\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  background-color: #f9f9fd;\n  padding: 17px 27px;\n  margin-bottom: 28px;\n}\n\n.info-grid {\n  display: flex;\n  gap: 20px;\n}\n\n.info-column {\n  flex: 1;\n}\n\n.info-label {\n  color: #ff4d53;\n  font: 700 10px/200% 'PP Neue Montreal', sans-serif;\n}\n\n.info-value {\n  color: rgba(0, 0, 0, 0.6);\n  font: 500 10px/200% 'PP Neue Montreal', sans-serif;\n  margin-bottom: 12px;\n}\n\n\n\n.social-media-link {\n  border-radius: 41px;\n  display: flex;\n  align-items: center;\n  padding: 6px 9px;\n  color: #fff;\n  font: 400 14px/143% Inter, sans-serif;\n  gap: 5px;\n}\n\n.social-icon {\n  width: 14px;\n  height: 14px;\n  margin-right: 6px;\n}\n\n.header-footer,\n.content-footer {\n  margin-top: 9px;\n  font: 400 10px/200% Inter, sans-serif;\n  color: #000;\n}\n.footer-content{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.decorative-line {\n  width: 100%;\n  height: 1px;\n  background-color: #b7b7b7;\n  margin-bottom: 9px;\n}\n\n.report-content {\n  background-color: #fff;\n  /* margin: 0 145px; */\n  padding: 45px;\n  margin-top: 45px;\n}\n\n.press-release-summary {\n  margin-bottom: 26px;\n}\n\n.press-release-title {\n  color: #000;\n  font: 500 16px/20px 'PP Neue Montreal', sans-serif;\n  margin: 25px 0 11px;\n}\n\n.submission-date {\n  color: rgba(0, 0, 0, 0.6);\n  font: 400 10px 'PP Neue Montreal', sans-serif;\n}\n\n.metrics-container {\n  display: flex;\n  gap: 20px;\n  margin-top: 26px;\n}\n\n.metric-item {\n  flex: 1;\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  background-color: #f9f9fd;\n  padding: 23px 36px;\n  text-align: center;\n}\n\n.metric-title {\n  color: #000;\n  font: 500 12px/167% 'PP Neue Montreal', sans-serif;\n}\n\n.metric-value {\n  color: #ff4d53;\n  font: 700 69px/143% 'PP Neue Montreal', sans-serif;\n  margin-top: 24px;\n}\n\n.pickup-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.pickup-row {\n  display: flex;\n  gap: 20px;\n}\n\n.pickup-section {\n  flex: 1;\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  background-color: #f9f9fd;\n  padding: 15px;\n  text-align: center;\n}\n\n.pickup-title {\n  color: #000;\n  font: 500 12px/167% 'PP Neue Montreal', sans-serif;\n  margin-bottom: 16px;\n}\n\n.platform-logo {\n  max-width: 120px;\n  height: auto;\n  margin-bottom: 16px;\n}\n\n.view-release-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 32px;\n  background-color: #ff4d53;\n  padding: 5px 10px;\n  color: #fff;\n  font: 500 10px/200% 'PP Neue Montreal', sans-serif;\n  text-transform: capitalize;\n}\n\n.arrow-icon {\n  width: 7px;\n  height: 8px;\n  margin-left: 6px;\n}\n\n.additional-info-image {\n  width: 100%;\n  height: auto;\n  margin: 16px 0;\n}\n\n.press-release-content,\n.additional-content {\n  background-color: #fff;\n  padding: 64px 45px 12px;\n  margin-top: 80px;\n}\n\n.press-release-text {\n  color: rgba(0, 0, 0, 0.6);\n  font: 500 13px/1.5 'PP Neue Montreal', sans-serif;\n  text-align: justify;\n  margin-bottom: 16px;\n  max-width: 100%;\n  overflow: hidden;\n}\n.press-release-text img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 0 auto;\n  object-fit: contain;\n}\n.editorClassName{\nheight: 352px !important;\n}\n.editorClassName img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 0 auto;\n  object-fit: contain;\n}\n.editorClassName a span {\n  color: #0000FF;\n}\n.noBorder-editor-wrapper {\n  border: none !important;\n}\n.noBorder-editor-main {\n  border: none !important;\n  box-shadow: none !important;\n}\n.rdw-editor-main img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 0 auto;\n  object-fit: contain;\n}\n.subsection-title {\n  color: #000;\n  font: 700 16px 'PP Neue Montreal', sans-serif;\n  margin: 30px 0 16px;\n}\n\n.company-link {\n  color: #0170f3;\n  text-decoration: underline;\n}\n\n.distribution-list {\n  background-color: #fff;\n  padding: 64px 45px 12px;\n  margin-top: 80px;\n}\n\n.distribution-item {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 14px 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.distribution-logo {\n  width: 43px;\n  height: auto;\n}\n\n.distribution-link {\n  color: #0170f3;\n  font: 500 10px/200% 'PP Neue Montreal', sans-serif;\n  text-decoration: none;\n}\n\n.distribution-type,\n.distribution-industry,\n.distribution-countries,\n.distribution-audience {\n  font: 400 10px/100% 'PP Neue Montreal', sans-serif;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n@media (max-width: 991px) {\n  .report-header,\n  .report-content,\n  .press-release-content,\n  .additional-content,\n  .distribution-list {\n    padding: 40px 20px;\n  }\n\n  .brand-name {\n    font-size: 40px;\n  }\n\n  .report-title {\n    font-size: 40px;\n  }\n\n  .info-grid {\n    flex-direction: column;\n  }\n\n  .metric-value {\n    font-size: 40px;\n  }\n\n  .pickup-row {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
